import React from 'react';
import { connect } from 'react-redux';
import { fetchEducations } from '../actions';
import Helmet from '../components/Helmet';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import PageCover from '../components/PageCover';
import {Grid, Typography} from '@material-ui/core';
import useDeepCompareEffect from 'use-deep-compare-effect'
import {Link} from "react-router-dom";

const useStyles = makeStyles(theme => ({
  tourBackground: {
    backgroundColor: '#fcfeff'
  },
  logoDiv: {
    padding: '100px 0px'
  }
}));


const EducationsPage = (props) => {

  const theme = useTheme(),
    { educations } = props,
    classes = useStyles(educations);

  useDeepCompareEffect(() => {
    console.log(educations)
    if (!educations.isLoaded) props.fetchEducations();
  }, [{isLoaded: false}])

  if (!educations.isLoaded) {
    return <div>Loading...</div>;
  }

  const PageCoverProps = {
    ...educations,
    style: {
      height: 'calc(100vh - 75px)',
      title: {
        position: 'absolute',
        top: 'auto',
        right: '0',
        bottom: '10%',
        left: 'auto',
        width: '33%',
        letterSpacing: '10px',
        backgroundColor: 'rgba(255,255,255,0.1)',
        color: 'white',
        fontWeight: '500',
        padding: '20px 0px 20px 5vw',
        borderTopLeftRadius: '40px',
        borderBottomLeftRadius: '40px',
        border: '1px solid #dadada',
        textShadow: '1px 1px 4px black',
        '& h1': {
          float: 'left',
          fontWeight: '500'
        },
        [theme.breakpoints.down('xs')] : {
          width: '75%',
        }
      }
    }
  };

  const rows = educations.files.map((d) => ({
    name: d.name,
    link: d.link
  }))

  return (
    <div className={classes.container}>
      <Helmet {...educations} />
      <div className={classes.tourBackground}>
        <PageCover {...PageCoverProps} >
          <Typography variant="h1">{educations.name}</Typography>
        </PageCover>

        <div style={{padding: '5%'}}>
          <Grid container alignItems="center" justify="center">
            <Grid item xs={12}>
              <h2>衛教文檔</h2>
            </Grid>
            {educations.files.map((d, i) => (
              <Grid key={i} container style={{padding: "1%", border: '1px solid black'}}>
                <Grid item xs={7} sm={6} style={{padding: "1%"}}>{d.name}</Grid>
                <Grid item xs={3} sm={4} style={{padding: "1%"}}>{d.date}</Grid>
                <Grid item xs={2} sm={2} style={{padding: "1%"}}><a href={d.link} target="_blank" download>下載</a></Grid>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps({educations}) {
  return { educations };
}

export default {
  loadData: ({dispatch}) => dispatch(fetchEducations()),
  component:  connect(mapStateToProps, { fetchEducations }) (EducationsPage)
}


// WEBPACK FOOTER //
// ./src/client/pages/EducationsPage.js